import script from "./PayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PayModal.vue?vue&type=script&setup=true&lang=js"

import "./PayModal.vue?vue&type=style&index=0&id=f186abb6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f186abb6"]])

export default __exports__